/** Alinhado ao interceptor em `api/config/axios.js` — fluxo esperado, não bug de app. */
export const AXIOS_BENIGN_HTTP_STATUSES = new Set([400, 401, 403, 404, 409, 422, 503]);

/**
 * @param {unknown} error
 */
export function isAxiosBenignHttpError(error) {
    const status = error?.response?.status;
    return typeof status === 'number' && AXIOS_BENIGN_HTTP_STATUSES.has(status);
}

/**
 * Erros Axios que a UI deve tratar sem alarmar o Sentry.
 * @param {unknown} error
 */
export function isAxiosBenignError(error) {
    return isAxiosBenignHttpError(error);
}
